<style scoped>


</style>


<template>

<div>
 
 q and a

</div>

</template>

<script>

export default{
    data:function(){
        return {}
    }
}

</script>


// WEBPACK FOOTER //
// src/assets/Dynamic/app/qa/main.vue